import React from 'react';
import classNames from 'classnames';
import { Footer, LangSwitch, AccountBanner } from '~/components';
import LogoPageLayout from '~/container/logo-page-layout';
import { getCurrentSuiteId, getSuiteView, isMobileUA } from '~/utils';
import MobileAccountLayout from '~/mixins/account/containers/mobile-account-layout';
import { AccountPageLayoutProps } from '../../../../../../interfaces';

/**
 * 登录/注册相关页面 布局组件
 */
const AccountPageLayout: React.FC<AccountPageLayoutProps> = (props) => {
    const {
        className,
        banner,
        showFooter,
        showLangSwitch,
        mobileAlignCenter,
        withSuite,
        suiteId,
        logoProps,
        children
    } = props;

    if (isMobileUA()) {
        return (
            <MobileAccountLayout
                className={className}
                showLangSwitch={showLangSwitch}
                alignCenter={mobileAlignCenter}
            >
                {children}
            </MobileAccountLayout>
        );
    }

    const resolvedSuiteId = suiteId ?? getCurrentSuiteId();

    const getDefaultBanner = () => {
        if (withSuite) {
            const bannerUrl = getSuiteView(resolvedSuiteId)?.banner_uri;
            return <AccountBanner bannerUrl={bannerUrl} />;
        }
        return <AccountBanner />;
    };

    return (
        <LogoPageLayout
            className={classNames('fx-account-page-layout', className)}
            logoProps={{
                showSuiteLogo: withSuite,
                suiteId: resolvedSuiteId,
                size: 'middle',
                ...logoProps
            }}
        >
            <div className="banner">
                {banner || getDefaultBanner()}
                {showFooter && <Footer />}
            </div>
            <div className="main">
                {showLangSwitch && <LangSwitch />}
                <div className="content">{children}</div>
            </div>
        </LogoPageLayout>
    );
};

export default AccountPageLayout;
